<template>
  <div>
    <div class="content-header">
      <div class="left">店铺设置</div>
      <!-- <div class="right">
        <Button v-if="!isEdite" type="primary" @click="isEdite = true"
          >修改</Button
        >
        <span v-else style="margin-left: 30px">
          <Button @click="isEdite = false" style="margin-right: 10px"
            >取消</Button
          >
          <Button @click="save()" type="success">保存</Button>
        </span>
      </div> -->
      <!-- <div class="bottom">
        <div class="bottom_left">
          <p class="tag_p">
            <span
              class="tag"
              @click="changeTabs(1)"
              :class="{ active: tabs == 1 }"
              >基础信息</span
            >
            <span
              class="tag"
              @click="changeTabs(2)"
              :class="{ active: tabs == 2 }"
              >店铺资质（{{
                data.check_status == -1
                  ? "提交实名认证"
                  : data.check_status === 0
                  ? "待审核"
                  : data.check_status === 1
                  ? "审核已通过"
                  : data.check_status === 2
                  ? "审核未通过"
                  : ""
              }}）</span
            >
          </p>
        </div>
      </div> -->
    </div>
    <div class="content_box">
      <div class="pageTitle">基本信息</div>
      <div class="fromBox_set">
        <div class="avatarBox">
          <img :src="data.logo" alt srcset class="avatar" />
          <!-- @click="selectLogo = true" -->
          <div class="edit">
            <Icon type="ios-brush" />
            <p>修改LOGO</p>
            <input
              type="file"
              class="inputlogo"
              @change="chooseImage($event)"
              accept="image/png, image/jpeg,  image/jpg"
            />
          </div>
        </div>

        <Form
          ref="form"
          class="setting-form-box"
          :model="data"
          :rules="rule"
          :label-width="120"
          label-colon
        >
          <FormItem label="店铺ID" prop="id" style="width: 50%">
            <Input v-model="data.random_str" disabled></Input>
          </FormItem>
          <FormItem label="店铺名称" prop="name" style="width: 50%">
            <Input v-model="data.name" :maxlength="12" disabled></Input>
            <div class="describe" v-if="shopName.id">
              当前状态：{{ shopNameStatus[shopName.status] }}
            </div>
            <div class="describe" v-else>如需修改店铺名称，可点击下方按钮修改并提交审核</div>
            <span class="name_btn" @click="editShopName"  v-if="shopName.id">{{shopName.status==0?"查看详情":shopName.status==2?"重新提交":"修改名称"}}</span>
            <span class="name_btn" @click="editShopName" v-else>修改名称</span>
          </FormItem>
          <FormItem label="超级管理员" style="width: 50%">
            <Input v-model="data.admin.tel" class="input" disabled></Input>
            <div class="describe">
              超级管理员拥有对店铺管理的最高权限，请警慎处理，
              <router-link :to="{ name: 'staff_list' }" class="btn_change"
                >修改</router-link
              >
            </div>
          </FormItem>
          <FormItem label="开通时间" prop="id" style="width: 50%">
            <Input :value="$moment(data.create_time)" disabled></Input>
          </FormItem>
          <FormItem label="店铺版本" prop="id" style="width: 50%">
            <Input
              :value="
                data.version_name +
                (data.version_name == '基础版'
                  ? '(永久免费)'
                  : '（' + $moment(data.operate_end, 'YYYY-MM-DD') + '到期)')
              "
              disabled
            ></Input>
            <div class="describe">
              你可以对店铺进行运营期延续或者店铺版本升级，
              <router-link
                :to="{ name: 'OperationPeriod_buy' }"
                class="btn_change"
                >去看看</router-link
              >
            </div>
          </FormItem>
          <FormItem label="主体认证" prop="id" style="width: 50%">
            <Input :value="auth_info" disabled></Input>
            <div v-if="data.auth.status != 1" class="describe">
              当前店铺还未进行主体认证，
              <router-link :to="{ name: 'shopAuth' }" class="btn_change"
                >去认证</router-link
              >
            </div>
          </FormItem>
        </Form>
      </div>
      <div class="pageTitle">
        通讯信息
        <span class="right" style="margin-left: 10px">
          <span
            v-if="!isEdite"
            style="color: #2d8cf0; cursor: pointer"
            @click="isEdite = true"
            >修改</span
          >
          <span v-else style="margin-left: 10px">
            <span @click="save()" style="color: #2d8cf0; cursor: pointer"
              >保存</span
            >
            <span
              @click="isEdite = false"
              style="margin-left: 10px; color: #ccc; cursor: pointer"
              >取消</span
            >
          </span>
        </span>
      </div>
      <div class="fromBox_set">
        <Form
          ref="form"
          class="setting-form-box"
          style="padding-left: 80px"
          :model="data"
          :rules="rule"
          :label-width="120"
          label-colon
        >
          <FormItem label="店铺负责人" prop="contacts" style="width: 50%">
            <Input v-model="data.contacts" :disabled="!isEdite"></Input>
          </FormItem>
          <FormItem label="负责人手机号" prop="contacts_tel" style="width: 50%">
            <Input
              v-model="data.contacts_tel"
              :maxlength="11"
              :disabled="!isEdite"
            ></Input>
          </FormItem>
          <FormItem label="所在地区" prop="location" style="width: 50%">
            <!-- <Cascader
              :data="area"
              v-model="data.location"
              style="width: 100%"
              :disabled="!isEdite"
            ></Cascader> -->
            <al-selector
              :gutter="0"
              data-type="name"
              searchable
              v-model="data.location"
              :disabled="!isEdite"
              level="2"
            />
          </FormItem>
          <!-- <FormItem label="详细地址" prop="address" style="width: 50%">
              <Input v-model="data.address"></Input>
            </FormItem> -->
          <FormItem label="邮箱" prop="email" style="width: 50%">
            <Input v-model="data.email" :disabled="!isEdite"></Input>
          </FormItem>
          <!-- <FormItem label="联系人" prop="contacts" style="width: 50%">
              <Input v-model="data.contacts"></Input>
            </FormItem> -->
          <FormItem label="客服电话" prop="service_tel" style="width: 50%">
            <Input v-model="data.service_tel" :disabled="!isEdite"></Input>
            <div class="describe">
              买家可通过客服电话与你联系，将展示在订单详情中
            </div>
          </FormItem>
          <FormItem label="店铺简介" prop="introduce" style="width: 50%">
            <Input
              type="textarea"
              v-model="data.introduce"
              :disabled="!isEdite"
              :maxlength="100"
              show-word-limit
              :autosize="{ minRows: 4 }"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div class="pageTitle">认证信息</div>
      <div class="auth_box">
        店铺主体认证：
        <span class="auth_info" v-if="data.auth.status == 1">
          <span>{{ auth_info }}</span>
        </span>
        <span v-if="data.auth.status == 0" class="auth_status"
          >店铺主体认证审核中，请耐心等待...
        </span>
        <span v-if="data.auth.status == 2" class="auth_status"
          >店铺主体认证审核未通过，点击“查看详情”了解原因并修改后重新提交审核！</span
        >
        <router-link v-if="!data.auth.id" :to="{ name: 'shopAuth' }">
          <Button>去认证</Button>
        </router-link>
        <router-link
          v-else
          :to="{ name: 'shopAuth' }"
          style="margin-left: 15px; font-size: 12px"
          >查看详情</router-link
        >
      </div>
    </div>

    <Modal v-model="modalShopName.status" title="店铺名称" width="800">
      <div>
        <div class="modal_shop_name_status">
          <span v-if="shopName.id">{{shopName.status==0?"审核中...":shopName.status==1?"审核通过，点击可修改并提交审核！":"审核驳回"}}</span>
          <span v-else>待提交审核，点击可修改并提交审核！</span>
          <div class="des" v-if="shopName.status==2&&shopName.note">驳回原因：{{shopName.note}}</div>
        </div>
        <Form :label-width="100">
          <FormItem label="店铺名称：">
            <Input
              style="width: 400px"
              type="text"
              placeholder="请输入店铺名称"
              :disabled='shopName.status==0'
              v-model="modalShopName.name"
            />
            <div style="color: #999999; font-size: 10px">
              请按店铺命名规范填写店铺名称，建议简洁12字以内，超出可能展示不全
            </div>
          </FormItem>
        </Form>
      </div>
      <div class="enc" style="padding-left: 10px; padding-bottom: 30px">
        <div class="tit">
          附件上传
          <span class="des"
            >（为了提高审核通过率，特殊店铺名称请按店铺命名规范提交相应资质证明）</span
          >
        </div>
        <div class="up_box">
          <Button type="primary" size="small" icon="md-add" :disabled='shopName.status==0'>添加附件</Button>
          <input type="file" class="file_input" :disabled='shopName.status==0' @change="uploadChangeOrder" />
        </div>
        <p class="tips">
          允许上传附件类型（pdf,doc,docx,xls,xlsx,txt,jpg,png），单个文件限
          5MB，最多5个文件
        </p>
        <p
          class="item"
          v-for="(item, index) in modalShopName.files"
          :key="index"
        >
          <Tag closable @on-close="deleteFiles(index)"> {{ item }}</Tag>
        </p>
        <!-- <p class="item">附件1.jpg</p> -->
        <div style="margin-top: 50px">
          <Checkbox v-model="isAgree"></Checkbox>我已阅读并同意
          <router-link
            tag="a"
            target="_blank"
            :to="{ path: '/other/name_standard' }"
            ><span style="color: #2d8cf0"
              >《自营新零售平台店铺命名规范》</span
            ></router-link
          >
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" @click="saveName" :disabled="!isAgree||shopName.status==0"
          >提交审核</Button
        >
        <Button @click="modalShopName.status = false" style="margin-right: 10px"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { uploadOSS } from "@/libs/util";
import { mapActions, mapGetters } from "vuex";
import areaData from "../../libs/city.data";
export default {
  data() {
    return {
      tabs: 1,
      id: 0,
      isEdite: false,
      auth_info: "未认证",
      data: {
        id: 0,
        company_name: "",
        name: "",
        province: "",
        city: "",
        area: "",
        location: [], //
        address: "",
        contacts: "",
        contacts_tel: "",
        account_bank: "",
        bank_no: "",
        licence: "",
        id_card: "",
        email: "",
        logo: "",
        introduce: "",
        account_name: "",
        Invoice_title: "",
        taxpayer_code: "",
        tel: "",
        user_id: 0,
        status: "",
        star: 0,
        is_recommend: 0,
        remote_city: "",
        remote_city_arr: [],
        reason: "",
        check_status: -1,
      },
      data1: {
        id: 0,
        agent_id: 0,
        id_card: null,
        licence: null,
        licence_other: [],
        check_status: 0,
      },
      rule: {
        name: [
          {
            required: true,
            type: "string",
            message: "请填写店铺名称",
            trigger: "select",
          },
        ],
        contacts_tel: [
          {
            type: "string",
            message: "请填写正确的手机号",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value)) {
                callback(new Error("请填写正确的手机号码"));
                return false;
              }
              callback();
            },
          },
        ],
        email: [
          {
            type: "email",
            message: "请填写正确的邮箱",
            trigger: "blur",
          },
        ],
      },
      area: areaData,
      upload: {
        card_a: {
          status: false,
          title: "身份证正面",
          width: 750,
          height: 400,
          path: "",
        },
        card_b: {
          status: false,
          title: "身份证反面",
          width: 750,
          height: 400,
          path: "",
        },
        logo: {
          status: false,
          title: "上传logo",
          width: 300,
          height: 300,
          path: "",
        },
        licence: {
          status: false,
          title: "营业执照",
          width: 750,
          height: 800,
          path: "",
        },
        licence_other: {
          status: false,
          title: "补充材料",
          width: 500,
          height: 500,
          path: [],
        },
        model: {
          status: false,
          title: "身份证正面",
          width: 750,
          height: 400,
          path: "",
          code: "card_a",
        },
      },
      loading: false,
      selectLogo: false,
      selectLogoModal: false,
      options: {
        src: "",
        blob: null,
        base64: "",
        mskOption: {
          width: 5,
          height: 5,
          isRound: true,
          resize: true,
          color: "rgba(0,247,255,0.49)",
          borderColor: "#E600FF",
        },
        backgroundColor: "rgb(255,0,0)",
        rotateControl: true,
        initAngle: 0,
        maxPixel: 500,
        encoderOptions: 0.8,
        format: "image/jpeg",
      },
      modalShopName: {
        status: false,
        name: "",
        files: [],
        data: [],
      },
      shopNameStatus: {
        0: "审核中...",
        1: "审核通过，点击可修改并提交审核！",
        2: "审核驳回，点击查看原因并重新提交审核！",
      },
      isAgree: true,
      shopName:{
        // name:'',
        // enclosure:null,
        // note: null,
        // status:2
      }
    };
  },
  methods: {
    ...mapActions(["GetShopInfo", "PutShopInfo","GetShopName"]),
    getData() {
      this.GetShopInfo().then((res) => {
        let data = res.data;
        data.location = [data.province, data.city, data.area];
        let card = data.id_card ? data.id_card.split(",") : [];
        this.upload.card_a.path = card.length ? card[0] : "";
        this.upload.card_b.path = card.length > 1 ? card[1] : "";
        this.upload.licence.path = data.licence;
        this.upload.logo.path = data.logo;
        data.remote_city_arr = data.remote_city
          ? data.remote_city.split(",")
          : [];
        this.data1 = {
          id: data.id,
          agent_id: data.agent_id,
          id_card: data.id_card,
          licence: data.licence,
          licence_other: data.licence_other,
          check_status: data.check_status,
        };
        this.upload.licence_other.path = data.licence_other
          ? data.licence_other.split(",")
          : [];
        this.data = data;

        if (data.auth.id) {
          if (data.auth.status == 1) {
            let name =
              data.auth.subject_type == 1
                ? "个人卖家"
                : data.auth.subject_type == 2
                ? "个体工商户"
                : "企业";
            this.auth_info =
              name +
              " / " +
              (data.auth.subject_type == 1
                ? data.auth.id_card_name + " / " + data.auth.id_card_number
                : data.auth.merchant_name +
                  " / " +
                  data.auth.business_license_number);
          } else if (data.auth.status == 0) {
            this.auth_info = "审核中";
          } else {
            this.auth_info = "审核失败";
          }
        }
      });
    },
    //获取店铺名称审核状态
    getShopNameStatus(){
      this.GetShopName().then(res=>{
        if(res.status){
          this.shopName = res.data;
        }
      })
    },
    uploadChange(e) {
      if (this.data.check_status !== -1 && this.data.check_status !== 2) {
        this.$Message.error("当前状态无法上传");
        return false;
      }
      if (
        this.upload.model.code === "licence_other" &&
        this.upload.licence_other.path.length >= 5
      ) {
        this.$Message.error("最多上传5张补充材料");
        return false;
      }
      let data = this.upload[e];
      data.status = true;
      data.code = e;
      this.upload.model = data;
      console.log(this.upload.model);
    },
    uploadInput(e) {
      this.upload.model.status = e;
    },
    getUrl(e, mode) {
      if (mode === "licence_other") {
        this.upload[mode].path.push(e);
      } else this.upload[mode].path = e;
    },
    save() {
      this.data.remote_city = this.data.remote_city_arr.join(",");
      let data = this.data;
      data.province = this.data.location[0];
      data.city = this.data.location[1];
      data.area = this.data.location[2];
      data.logo = undefined;
      this.loading = true;

       if (
          data.contacts &&
          data.contacts_tel &&
          data.location &&
          data.email &&
          data.service_tel &&
          data.introduce
        ) {
    
          this.PutShopInfo(this.data).then((res) => {
            this.loading = false;
            this.isEdite = false;
            this.$Message[res.status ? "success" : "error"](res.msg);
            if (!res.status) return false;
            this.getData();
          });
        }else{
           this.$Message.error("请完善店铺通讯信息!");
        }
    },
    saveName() {
      let name = this.modalShopName.name;
      if (!name) {
        this.$Message.error("请输入店铺名称!");
        return
      }
      if(name===this.data.name){
        this.$Message.error("不能与当前店铺名称相同!");
        return
      }
      let arr = [
        "云知印",
        "aidprint",
        "自营新零售",
        "aidbuys",
        "中国",
        "国家",
        "政府",
        "军队",
        "共产党",
        "解放军",
        "毛泽东",
        "邓小平",
        "周恩来",
        "胡锦涛",
        "江泽民",
        "习近平",
        "李克强",
      ];
      let reg = new RegExp(arr.join("|"), "g");
      if (name.match(reg)) {
        // 包含敏感词
        this.$Message.error("请按店铺名称规范填写店铺名称!");
        return;
      }
      let data = {
        id: this.data.id,
        name: name,
      };
      if (this.modalShopName.data.length) {
        data.qualifications = this.modalShopName.data.join(",");
      }
      this.PutShopInfo(data).then((res) => {
        this.modalShopName.status = false;
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (!res.status) return false;
        this.getData();
      });
    },
    saveCheck() {
      let data = JSON.parse(JSON.stringify(this.data1));
      if (!this.upload.card_a.path) {
        this.$Message.error("请上传身份证正面");
        return false;
      }
      if (!this.upload.card_b.path) {
        this.$Message.error("请上传身份证背面");
        return false;
      }
      if (!this.upload.licence.path) {
        this.$Message.error("请上传营业执照");
        return false;
      }
      data.reason = "";
      data.id_card = `${this.upload.card_a.path},${this.upload.card_b.path}`;
      data.licence = this.upload.licence.path;
      data.licence_other = this.upload.licence_other.path.length
        ? this.upload.licence_other.path.join(",")
        : "";
      if (data.check_status == -1 || data.check_status == 2)
        data.check_status = 0;
      this.loading = true;
      this.PutShopInfo(data).then((res) => {
        this.loading = false;
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (!res.status) return false;
        this.getData();
      });
    },
    cityChange(e) {
      this.data.remote_city_arr = e;
    },
    changeTabs(e) {
      this.tabs = e;
    },

    btnEdit() {},
    chooseImage(e) {
      let file = e.target.files[0];
      if (file) {
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
          this.$Message.error("仅支持图片文件");
          return;
        }
        this.options.src = URL.createObjectURL(file);
        this.selectLogoModal = true;
      }
    },
    cutChange({ blob, base64 }) {
      this.options.blob = blob;
      this.options.base64 = base64;

      var file = new File([blob], `${Date.now()}.jpg`, {
        type: "image/png",
        lastModified: Date.now(),
      });
      uploadOSS(`shop/${this.data.shop_id}`, file).then((oss) => {
        console.log("oss.url", oss.url);
        this.selectLogoModal = false;
        let d = { id: this.shop.id, logo: oss.url };
        this.PutShopInfo(d).then((res) => {
          this.$Message[res.status ? "success" : "error"](res.msg);
          if (!res.status) return false;
          this.shopInfo();
        });
      });
    },
    editShopName() {
      this.modalShopName.status = true;
      this.modalShopName.name = this.shopName.name;
      let files = this.shopName.enclosure.split(',');
      this.modalShopName.files = files;
    },
    uploadChangeOrder(e) {
      let file = e.target.files[0];
      if (file.size > 5242880) {
        this.$Notice.warning({
          title: "上传失败",
          desc: `文件”${files[i].name}“过大`,
        });
        return false;
      }
      this.$Spin.show();
      let date = this.$moment(new Date(), "YYYY-MM-DD");
      let src = `shop/${this.data.shop_id}/order/shop_id-${this.data.shop_id}/${date}/files/`;
      uploadOSS(src, file).then((oss) => {
        this.$Spin.hide();
        this.modalShopName.data.push(oss.url);
        this.modalShopName.files.push(file.name);
      });
    },
    deleteFiles(index) {
      this.modalShopName.files.splice(index, 1);
      this.modalShopName.data.splice(index, 1);
    },
  },
  mounted() {
    this.getData();
    this.getShopNameStatus();
    // if (this.$route.query.a) this.tabs = this.$route.query.a;
  },
  created() {},
};
</script>

<style type="text/css" lang="less" >
@import "./setting.less";
</style>
